import './styles.scss';
import Moment from 'react-moment';
import CopyToClipboard from 'react-copy-to-clipboard';
import Parser from 'html-react-parser';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import l from '../../../../lang';
import ChipStatus from '../../../common/chip-status';
import { Urls } from '../../../../config/urls';
import { createDate, getMappedCountryCode } from '../../../../utils';
import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Loading from '../../../common/loading';
import Card from '../../../common/card';
import { ReactComponent as CopyIcon } from '../../../../assets/icons/copy.svg';
import { ReactComponent as CardIcon } from '../../../../assets/icons/card.svg';
import { ReactComponent as FileDownload } from '../../../../assets/icons/file-download.svg';
import { Tooltip } from '@mui/material';
import { PaymentMethodTypes } from '../../../../constants';
import { useDashboard } from '../../../../store/dashboard';
import { Button } from '../../../common/button';
import { useRefunds } from '../../../../store/refunds';
import { Routes } from '../../../../config/routes';
import TopDashboardSection from '../../../common/top-dashboard-section';
import ButtonLink from '../../../common/button-link';
import { ReactComponent as BackIcon } from '../../../../assets/icons/back.svg';
import MessageError from '../../../common/message-error';

const RefundDetail = () => {
  let { invoice_id: refundId } = useParams<{ invoice_id: string }>();
  const { merchantMe } = useDashboard();
  const { allRefunds, refundDetail, setRefundDetail, getRefundDetail, exportRefundDetail } = useRefunds();
  const { loading, data, error, errorInfo } = refundDetail;
  const [wasCopied, setWasCopied] = useState(false);

  const history = useHistory();

  useEffect(() => {
    const trans = allRefunds?.data.find(t => t.id === Number(refundId));
    if (trans?.id === Number(refundId)) {
      setRefundDetail(trans);
    } else {
      getRefundDetail(Number(refundId));
    }
  }, []);

  const exportToPDF = () => {
    exportRefundDetail(Number(refundId));
  };

  return (
    <>
      <TopDashboardSection
        title={l('refunds.details')}
        componentBottom={
          <div className="transaction_detail__back_btn">
            <ButtonLink
              type="secondary"
              text={
                <>
                  <BackIcon /> {l('refunds.details.backBtn')}
                </>
              }
              onClick={() => history.push(Routes.REFUNDS)}
            />
          </div>
        }
      />
      <div className="transaction_detail">
        <div className="transaction_detail__export_btn">
          <Button
            textTransformNone
            startIcon={<FileDownload />}
            size="small"
            style={{ backgroundColor: '#F5F5F5' }}
            color="primary"
            variant="outlined"
            onClick={exportToPDF}
          >
            Export to PDF
          </Button>
        </div>
        <div id="capture">
          <Card>
            {loading && <Loading />}
            {!loading && data && error && <MessageError errorInfo={errorInfo} />}
            {!loading && data && !error && (
              <>
                <div className="transaction_detail__card_section">
                  <div className="transaction_detail__amount_paid">
                    <div className="transaction_detail__amount_paid__title">{l('transactions.amountPaid')}</div>
                    <div className="transaction_detail__amount_paid__value">
                      {data.currency} {data.localAmount}
                    </div>
                  </div>
                  <div className="transaction_detail__status">
                    <div className="transaction_detail__status__title">{l('transactions.status')}</div>
                    <div className="transaction_detail__status__value">
                      <ChipStatus status={data.status} text={l(`transactions.status.${data.status}`)} />
                    </div>
                  </div>
                  <div className="transaction_detail__divider" />
                  <div className="refund_details_row">
                    <div className="transaction_detail__box_data transaction_detail__box_data__date">
                      <div className="transaction_detail__box_data__title">{l('transactions.date')}</div>
                      <div className="transaction_detail__box_data__value">
                        <Moment format="DD/MM/YYYY">{createDate(data.date)}</Moment>
                        <span>, </span>
                        <Moment format="hh:mm:ss a">{createDate(data.date)}</Moment>
                      </div>
                    </div>
                    <div className="transaction_detail__box_data transaction_detail__box_data__border_left">
                      <div className="transaction_detail__box_data__title">{l('refunds.id')}</div>
                      <div className="transaction_detail__box_data__value">
                        <div className="transaction_detail__box_data__value__one_line">{data.id}</div>
                      </div>
                    </div>
                    <div className="transaction_detail__box_data transaction_detail__box_data__border_left">
                      <div className="transaction_detail__box_data__title">{l('refunds.transactionId')}</div>
                      <div className="transaction_detail__box_data__value">
                        {data.transactionExternalId ? (
                          <>
                            <div className="transaction_detail__box_data__value__one_line">{data.transactionExternalId}</div>
                            <CopyToClipboard
                              text={data.transactionExternalId}
                              onCopy={() => {
                                setWasCopied(true);
                              }}
                            >
                              <Tooltip
                                onMouseEnter={() => setWasCopied(false)}
                                title={l(wasCopied ? 'common.copied' : 'common.copy')}
                              >
                                <CopyIcon className="transaction_detail__box_data__value__icon no_export" />
                              </Tooltip>
                            </CopyToClipboard>
                          </>
                        ) : (
                          <span>-</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="transaction_detail__card_section">
                  <div>
                    <div className="transaction_detail__title_section">
                      <div className="transaction_detail__title_section__text">
                        <CardIcon className="transaction_detail__title_section__icon" />
                        {l('refunds.details')}
                      </div>
                    </div>
                    <div className="transaction_detail__data_section">
                      <div className="transaction_detail__box_detail">
                        <div className="transaction_detail__box_detail__row">
                          <div className="transaction_detail__box_detail__row__label">
                            <div className="transaction_detail__box_detail__row__label__text">
                              {l('refunds.details.issuedBy')}
                            </div>
                          </div>
                          <div className="transaction_detail__box_detail__row__value">{merchantMe?.name}</div>
                        </div>

                        <div className="transaction_detail__box_detail__row">
                          <div className="transaction_detail__box_detail__row__label">
                            <div className="transaction_detail__box_detail__row__label__text">
                              {l('refunds.details.paidTo')}
                            </div>
                          </div>
                          <div className="transaction_detail__box_detail__row__value">
                            {data.clientFirstName} {data.clientLastName}
                          </div>
                        </div>

                        <div className="transaction_detail__box_detail__row">
                          <div className="transaction_detail__box_detail__row__label_bottom">
                            {l('refunds.details.amountPaid')}
                          </div>
                          <div className="transaction_detail__box_detail__row__value_bottom">
                            {data.balanceCurrency} {data.balanceAmount}
                          </div>
                        </div>
                      </div>

                      <div className="transaction_detail__table_detail transaction_detail__column_right">
                        <div className="transaction_detail__table_detail__row">
                          <div className="transaction_detail__table_detail__row__label">{l('transactions.country')}</div>
                          <div className="transaction_detail__table_detail__row__value">
                            <img
                              alt=""
                              className="transaction_detail__country__flag country-flag--rounded"
                              src={`${Urls.roundedFlags.replace(':code', getMappedCountryCode(data.country))}`}
                            />
                            <span>&nbsp;{l(`countryCode.${data.country}`)}</span>
                          </div>
                        </div>
                        <div className="transaction_detail__table_detail__row">
                          <div className="transaction_detail__table_detail__row__label">
                            {l('transactions.paymentMethod')}
                          </div>
                          <div className="transaction_detail__table_detail__row__value">{data.paymentMethod}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </Card>
        </div>
      </div>
    </>
  );
};

export default RefundDetail;
